$( document ).ready(function() {
	
  
  $('.inventory-pop-up span').click(function() {
  		$( ".inventory-overlay" ).css('display','block');
    
	}); 
  
  $('.inventory-overlay').click(function() {
    $( ".inventory-overlay" ).css('display','none');
	}); 
  
  $('.pop-close').click(function() {
  		$( ".inventory-overlay" ).css('display','none');
	}); 
  
  
});